export default __webpack_public_path__ + "static/media/cp_geo_us.193d7f19.svg";